import { render } from "./회원가입_step4.vue?vue&type=template&id=6b4b8b52"
import script from "./회원가입_step4.vue?vue&type=script&lang=js"
export * from "./회원가입_step4.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__